import { gql } from 'graphql-request';
import { request } from '../graphql';

export const GET_LUZMO_EMBED_TOKEN_ADMIN = gql`
  query luzmoEmbedTokenAdmin($input:LuzmoSsoInput!) {
    luzmoEmbedTokenAdmin(input:$input) {
      id
      token
    }
  }
`;

export type GetLuzmoEmbedTokenAdmin = {
    luzmoEmbedTokenAdmin: {
    id: string;
    token: string;
  }
}

interface GetLuzmoEmbedTokenAdminArgs {
  realTime: boolean;
  accessOfDashboard?: string;
  forCompany?: string;
}
export const getLuzmoEmbedTokenAdmin = (args: GetLuzmoEmbedTokenAdminArgs) =>
  request<GetLuzmoEmbedTokenAdmin>(GET_LUZMO_EMBED_TOKEN_ADMIN, { input: { ...args } });
